// extracted by mini-css-extract-plugin
export default {"input":"d_-z","button":"e_-z","selected":"f_-z","unavailable":"g_-z","oos":"h_-z","image":"i_-z","paperCutDisabledOverlay":"j_-z"};